// DO NOT EDIT -- generated from fs/services/emissary/emissary.proto

import { Capability, IntegrationField, Note, SendModal, UserDetailLink } from './model.proto';
import { WebhookSendContentMetadata } from './webhooks.proto';
import * as mapping from './mapping';
import * as protobuf from '../../../google/protobuf';
import * as signalstudio from '../../api/signalstudio';
import * as vars from '../../api/vars';

export namespace Emissary {

  export const GetIntegrationConfigSummariesEndpoint = "/grpc/emissary.Emissary/GetIntegrationConfigSummaries";
  /**
   * Accepts a collection of integration config ids and returns a map of config ids to config summaries.
   * Config summaries show user friendly information about what the configuration has access to.
   */
  export function GetIntegrationConfigSummaries(sender: (req: GetIntegrationConfigSummariesRequest, endpoint: string) => Promise<GetIntegrationConfigSummariesResponse>, req: GetIntegrationConfigSummariesRequest): { promise: () => Promise<GetIntegrationConfigSummariesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationConfigSummariesEndpoint),
      endpoint: GetIntegrationConfigSummariesEndpoint
    };
  }

  export const GetSendNoteIntegrationsEndpoint = "/grpc/emissary.Emissary/GetSendNoteIntegrations";
  /**
   * Returns the set of integration ids for this org that can send notes.
   * Used by session playback to decide which "send to ..." entries to show.
   */
  export function GetSendNoteIntegrations(sender: (req: SendNoteIntegrationsRequest, endpoint: string) => Promise<SendNoteIntegrationsResponse>, req: SendNoteIntegrationsRequest): { promise: () => Promise<SendNoteIntegrationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSendNoteIntegrationsEndpoint),
      endpoint: GetSendNoteIntegrationsEndpoint
    };
  }

  export const GetIntegrationScriptsEndpoint = "/grpc/emissary.Emissary/GetIntegrationScripts";
  /**
   * Returns a JS script containing the combined code snippets of each of the enabled client-injection integrations.
   * Should only be called machine-to-machine.
   */
  export function GetIntegrationScripts(sender: (req: IntegrationScriptsRequest, endpoint: string) => Promise<IntegrationScriptsResponse>, req: IntegrationScriptsRequest): { promise: () => Promise<IntegrationScriptsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationScriptsEndpoint),
      endpoint: GetIntegrationScriptsEndpoint
    };
  }

  export const BroadcastNoteEndpoint = "/grpc/emissary.Emissary/BroadcastNote";
  /** Broadcasts a note out to all integrations which support this; use only when notes are created. */
  export function BroadcastNote(sender: (req: BroadcastNoteRequest, endpoint: string) => Promise<BroadcastNoteResponse>, req: BroadcastNoteRequest): { promise: () => Promise<BroadcastNoteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, BroadcastNoteEndpoint),
      endpoint: BroadcastNoteEndpoint
    };
  }

  export const SendNoteEndpoint = "/grpc/emissary.Emissary/SendNote";
  /** Send a note to an installed integration. */
  export function SendNote(sender: (req: SendNoteRequest, endpoint: string) => Promise<SendNoteResponse>, req: SendNoteRequest): { promise: () => Promise<SendNoteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, SendNoteEndpoint),
      endpoint: SendNoteEndpoint
    };
  }

  export const GetAutocompleteValuesEndpoint = "/grpc/emissary.Emissary/GetAutocompleteValues";
  /** Get autocomplete field values for sending Notes. */
  export function GetAutocompleteValues(sender: (req: AutocompleteRequest, endpoint: string) => Promise<AutocompleteResponse>, req: AutocompleteRequest): { promise: () => Promise<AutocompleteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAutocompleteValuesEndpoint),
      endpoint: GetAutocompleteValuesEndpoint
    };
  }

  export const GetSendNoteModalEndpoint = "/grpc/emissary.Emissary/GetSendNoteModal";
  /** Gets the details associated with the modal dialog that some services show as part of sending a note. */
  export function GetSendNoteModal(sender: (req: SendNoteModalRequest, endpoint: string) => Promise<SendNoteModalResponse>, req: SendNoteModalRequest): { promise: () => Promise<SendNoteModalResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSendNoteModalEndpoint),
      endpoint: GetSendNoteModalEndpoint
    };
  }

  export const GetUserCardUrlsEndpoint = "/grpc/emissary.Emissary/GetUserCardUrls";
  export function GetUserCardUrls(sender: (req: UserCardUrlsRequest, endpoint: string) => Promise<UserCardUrlsResponse>, req: UserCardUrlsRequest): { promise: () => Promise<UserCardUrlsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetUserCardUrlsEndpoint),
      endpoint: GetUserCardUrlsEndpoint
    };
  }

  export const GetAvailableIntegrationsEndpoint = "/grpc/emissary.Emissary/GetAvailableIntegrations";
  export function GetAvailableIntegrations(sender: (req: GetAvailableIntegrationsRequest, endpoint: string) => Promise<GetAvailableIntegrationsResponse>, req: GetAvailableIntegrationsRequest): { promise: () => Promise<GetAvailableIntegrationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAvailableIntegrationsEndpoint),
      endpoint: GetAvailableIntegrationsEndpoint
    };
  }

  export const GetInstalledIntegrationsEndpoint = "/grpc/emissary.Emissary/GetInstalledIntegrations";
  /** List all the integrations installed for the provided org. */
  export function GetInstalledIntegrations(sender: (req: GetInstalledIntegrationsRequest, endpoint: string) => Promise<GetInstalledIntegrationsResponse>, req: GetInstalledIntegrationsRequest): { promise: () => Promise<GetInstalledIntegrationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInstalledIntegrationsEndpoint),
      endpoint: GetInstalledIntegrationsEndpoint
    };
  }

  export const GetIntegrationDetailsEndpoint = "/grpc/emissary.Emissary/GetIntegrationDetails";
  export function GetIntegrationDetails(sender: (req: IntegrationDetailsRequest, endpoint: string) => Promise<IntegrationDetails>, req: IntegrationDetailsRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationDetailsEndpoint),
      endpoint: GetIntegrationDetailsEndpoint
    };
  }

  export const GetIntegrationDetailsByProviderIdEndpoint = "/grpc/emissary.Emissary/GetIntegrationDetailsByProviderId";
  /** GetIntegrationDetailsByProviderId gets the service details about the requested integration, given a provider (service) ID, e.g. "slack". */
  export function GetIntegrationDetailsByProviderId(sender: (req: IntegrationDetailsByProviderIdRequest, endpoint: string) => Promise<IntegrationDetails>, req: IntegrationDetailsByProviderIdRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationDetailsByProviderIdEndpoint),
      endpoint: GetIntegrationDetailsByProviderIdEndpoint
    };
  }

  export const InstallIntegrationEndpoint = "/grpc/emissary.Emissary/InstallIntegration";
  /** Install an integration to an org. */
  export function InstallIntegration(sender: (req: InstallIntegrationRequest, endpoint: string) => Promise<InstalledIntegration>, req: InstallIntegrationRequest): { promise: () => Promise<InstalledIntegration>, endpoint: string } {
    return {
      promise: () => sender(req, InstallIntegrationEndpoint),
      endpoint: InstallIntegrationEndpoint
    };
  }

  export const UpdateIntegrationConfigEndpoint = "/grpc/emissary.Emissary/UpdateIntegrationConfig";
  /** Update one or more settings for an integration. */
  export function UpdateIntegrationConfig(sender: (req: UpdateIntegrationConfigRequest, endpoint: string) => Promise<IntegrationDetails>, req: UpdateIntegrationConfigRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateIntegrationConfigEndpoint),
      endpoint: UpdateIntegrationConfigEndpoint
    };
  }

  export const UpdateInstalledIntegrationEndpoint = "/grpc/emissary.Emissary/UpdateInstalledIntegration";
  /** Update the installation settings of an integration */
  export function UpdateInstalledIntegration(sender: (req: UpdateInstalledIntegrationRequest, endpoint: string) => Promise<InstalledIntegration>, req: UpdateInstalledIntegrationRequest): { promise: () => Promise<InstalledIntegration>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateInstalledIntegrationEndpoint),
      endpoint: UpdateInstalledIntegrationEndpoint
    };
  }

  export const ConvertIntegrationScopeEndpoint = "/grpc/emissary.Emissary/ConvertIntegrationScope";
  /** Convert an installed integration to use a different configuration scope. Warning: All existing configs will be deleted. */
  export function ConvertIntegrationScope(sender: (req: ConvertIntegrationScopeRequest, endpoint: string) => Promise<InstalledIntegration>, req: ConvertIntegrationScopeRequest): { promise: () => Promise<InstalledIntegration>, endpoint: string } {
    return {
      promise: () => sender(req, ConvertIntegrationScopeEndpoint),
      endpoint: ConvertIntegrationScopeEndpoint
    };
  }

  export const UninstallIntegrationEndpoint = "/grpc/emissary.Emissary/UninstallIntegration";
  /** Removes the integration from the org and returns a redirect URL, if any. */
  export function UninstallIntegration(sender: (req: UninstallIntegrationRequest, endpoint: string) => Promise<{}>, req: UninstallIntegrationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UninstallIntegrationEndpoint),
      endpoint: UninstallIntegrationEndpoint
    };
  }

  export const CreateIntegrationConfigEndpoint = "/grpc/emissary.Emissary/CreateIntegrationConfig";
  /** Creates a new integration config for an org or user. */
  export function CreateIntegrationConfig(sender: (req: CreateIntegrationConfigRequest, endpoint: string) => Promise<IntegrationConfig>, req: CreateIntegrationConfigRequest): { promise: () => Promise<IntegrationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, CreateIntegrationConfigEndpoint),
      endpoint: CreateIntegrationConfigEndpoint
    };
  }

  export const DeleteIntegrationConfigEndpoint = "/grpc/emissary.Emissary/DeleteIntegrationConfig";
  /** Allows admins/users to delete their integration configs. */
  export function DeleteIntegrationConfig(sender: (req: DeleteIntegrationConfigRequest, endpoint: string) => Promise<{}>, req: DeleteIntegrationConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIntegrationConfigEndpoint),
      endpoint: DeleteIntegrationConfigEndpoint
    };
  }

  export const DeprecatedInstallIntegrationEndpoint = "/grpc/emissary.Emissary/DeprecatedInstallIntegration";
  /** Deprecated: Install and add configuration for an integration to an org. */
  export function DeprecatedInstallIntegration(sender: (req: DeprecatedInstallIntegrationRequest, endpoint: string) => Promise<IntegrationConfig>, req: DeprecatedInstallIntegrationRequest): { promise: () => Promise<IntegrationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, DeprecatedInstallIntegrationEndpoint),
      endpoint: DeprecatedInstallIntegrationEndpoint
    };
  }

  export const ConnectIntegrationEndpoint = "/grpc/emissary.Emissary/ConnectIntegration";
  export function ConnectIntegration(sender: (req: ConnectIntegrationRequest, endpoint: string) => Promise<ConnectIntegrationResponse>, req: ConnectIntegrationRequest): { promise: () => Promise<ConnectIntegrationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ConnectIntegrationEndpoint),
      endpoint: ConnectIntegrationEndpoint
    };
  }

  export const UpdateIntegrationConnectionEndpoint = "/grpc/emissary.Emissary/UpdateIntegrationConnection";
  export function UpdateIntegrationConnection(sender: (req: UpdateIntegrationConnectionRequest, endpoint: string) => Promise<{}>, req: UpdateIntegrationConnectionRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateIntegrationConnectionEndpoint),
      endpoint: UpdateIntegrationConnectionEndpoint
    };
  }

  export const DisconnectIntegrationEndpoint = "/grpc/emissary.Emissary/DisconnectIntegration";
  export function DisconnectIntegration(sender: (req: DisconnectIntegrationRequest, endpoint: string) => Promise<{}>, req: DisconnectIntegrationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DisconnectIntegrationEndpoint),
      endpoint: DisconnectIntegrationEndpoint
    };
  }

  export const GetAuthUrlEndpoint = "/grpc/emissary.Emissary/GetAuthUrl";
  /** Gets the authorization URL for an OAuth integration. */
  export function GetAuthUrl(sender: (req: GetAuthUrlRequest, endpoint: string) => Promise<GetAuthUrlResponse>, req: GetAuthUrlRequest): { promise: () => Promise<GetAuthUrlResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthUrlEndpoint),
      endpoint: GetAuthUrlEndpoint
    };
  }

  export const UpdateAuthTokenEndpoint = "/grpc/emissary.Emissary/UpdateAuthToken";
  export function UpdateAuthToken(sender: (req: UpdateAuthTokenRequest, endpoint: string) => Promise<UpdateAuthTokenResponse>, req: UpdateAuthTokenRequest): { promise: () => Promise<UpdateAuthTokenResponse>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAuthTokenEndpoint),
      endpoint: UpdateAuthTokenEndpoint
    };
  }

  export const UpdateAuthTokenOAuth1Endpoint = "/grpc/emissary.Emissary/UpdateAuthTokenOAuth1";
  export function UpdateAuthTokenOAuth1(sender: (req: UpdateAuthTokenOAuth1Request, endpoint: string) => Promise<UpdateAuthTokenOAuth1Response>, req: UpdateAuthTokenOAuth1Request): { promise: () => Promise<UpdateAuthTokenOAuth1Response>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateAuthTokenOAuth1Endpoint),
      endpoint: UpdateAuthTokenOAuth1Endpoint
    };
  }

  export const GetAuthTokenStatusEndpoint = "/grpc/emissary.Emissary/GetAuthTokenStatus";
  export function GetAuthTokenStatus(sender: (req: GetAuthTokenStatusRequest, endpoint: string) => Promise<GetAuthTokenStatusResponse>, req: GetAuthTokenStatusRequest): { promise: () => Promise<GetAuthTokenStatusResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthTokenStatusEndpoint),
      endpoint: GetAuthTokenStatusEndpoint
    };
  }

  export const GetAuthTokenStatusesEndpoint = "/grpc/emissary.Emissary/GetAuthTokenStatuses";
  export function GetAuthTokenStatuses(sender: (req: GetAuthTokenStatusesRequest, endpoint: string) => Promise<GetAuthTokenStatusesResponse>, req: GetAuthTokenStatusesRequest): { promise: () => Promise<GetAuthTokenStatusesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthTokenStatusesEndpoint),
      endpoint: GetAuthTokenStatusesEndpoint
    };
  }

  export const GetIntegrationUsersEndpoint = "/grpc/emissary.Emissary/GetIntegrationUsers";
  export function GetIntegrationUsers(sender: (req: GetIntegrationUsersRequest, endpoint: string) => Promise<GetIntegrationUsersResponse>, req: GetIntegrationUsersRequest): { promise: () => Promise<GetIntegrationUsersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationUsersEndpoint),
      endpoint: GetIntegrationUsersEndpoint
    };
  }

  export const GetConnectionByServiceIdForInternalUseEndpoint = "/grpc/emissary.Emissary/GetConnectionByServiceIdForInternalUse";
  /**
   * ONLY FOR INTERNAL USE - Gets a connection with unencrypted auth info for another FS service to use.
   * This is a temporary method intended to be used by slacker in order to access integration data via emissary.
   */
  export function GetConnectionByServiceIdForInternalUse(sender: (req: ConnectionByServiceIdRequest, endpoint: string) => Promise<IntegrationConnection>, req: ConnectionByServiceIdRequest): { promise: () => Promise<IntegrationConnection>, endpoint: string } {
    return {
      promise: () => sender(req, GetConnectionByServiceIdForInternalUseEndpoint),
      endpoint: GetConnectionByServiceIdForInternalUseEndpoint
    };
  }
}

export namespace EmissaryPublic {

  export const GetIntegrationConfigSummariesEndpoint = "/grpc/emissary.EmissaryPublic/GetIntegrationConfigSummaries";
  /**
   * Accepts a collection of integration config ids and returns a map of config ids to config summaries.
   * Config summaries show user friendly information about what the configuration has access to.
   */
  export function GetIntegrationConfigSummaries(sender: (req: GetIntegrationConfigSummariesRequest, endpoint: string) => Promise<GetIntegrationConfigSummariesResponse>, req: GetIntegrationConfigSummariesRequest): { promise: () => Promise<GetIntegrationConfigSummariesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationConfigSummariesEndpoint),
      endpoint: GetIntegrationConfigSummariesEndpoint
    };
  }

  export const GetAvailableIntegrationsEndpoint = "/grpc/emissary.EmissaryPublic/GetAvailableIntegrations";
  export function GetAvailableIntegrations(sender: (req: GetAvailableIntegrationsRequest, endpoint: string) => Promise<GetAvailableIntegrationsResponse>, req: GetAvailableIntegrationsRequest): { promise: () => Promise<GetAvailableIntegrationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAvailableIntegrationsEndpoint),
      endpoint: GetAvailableIntegrationsEndpoint
    };
  }

  export const GetInstalledIntegrationsEndpoint = "/grpc/emissary.EmissaryPublic/GetInstalledIntegrations";
  /** List all the integrations installed for the provided org. */
  export function GetInstalledIntegrations(sender: (req: GetInstalledIntegrationsRequest, endpoint: string) => Promise<GetInstalledIntegrationsResponse>, req: GetInstalledIntegrationsRequest): { promise: () => Promise<GetInstalledIntegrationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetInstalledIntegrationsEndpoint),
      endpoint: GetInstalledIntegrationsEndpoint
    };
  }

  export const GetIntegrationDetailsEndpoint = "/grpc/emissary.EmissaryPublic/GetIntegrationDetails";
  /** Get service details about the requested integration. */
  export function GetIntegrationDetails(sender: (req: IntegrationDetailsRequest, endpoint: string) => Promise<IntegrationDetails>, req: IntegrationDetailsRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationDetailsEndpoint),
      endpoint: GetIntegrationDetailsEndpoint
    };
  }

  export const GetIntegrationDetailsByProviderIdEndpoint = "/grpc/emissary.EmissaryPublic/GetIntegrationDetailsByProviderId";
  /** GetIntegrationDetailsByProviderId gets the service details about the requested integration, given a provider (service) ID, e.g. "slack". */
  export function GetIntegrationDetailsByProviderId(sender: (req: IntegrationDetailsByProviderIdRequest, endpoint: string) => Promise<IntegrationDetails>, req: IntegrationDetailsByProviderIdRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationDetailsByProviderIdEndpoint),
      endpoint: GetIntegrationDetailsByProviderIdEndpoint
    };
  }

  export const InstallIntegrationEndpoint = "/grpc/emissary.EmissaryPublic/InstallIntegration";
  /** Install an integration to an org. */
  export function InstallIntegration(sender: (req: InstallIntegrationRequest, endpoint: string) => Promise<InstalledIntegration>, req: InstallIntegrationRequest): { promise: () => Promise<InstalledIntegration>, endpoint: string } {
    return {
      promise: () => sender(req, InstallIntegrationEndpoint),
      endpoint: InstallIntegrationEndpoint
    };
  }

  export const UpdateIntegrationConfigEndpoint = "/grpc/emissary.EmissaryPublic/UpdateIntegrationConfig";
  /** Update one or more settings for an integration. */
  export function UpdateIntegrationConfig(sender: (req: UpdateIntegrationConfigRequest, endpoint: string) => Promise<IntegrationDetails>, req: UpdateIntegrationConfigRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateIntegrationConfigEndpoint),
      endpoint: UpdateIntegrationConfigEndpoint
    };
  }

  export const UpdateInstalledIntegrationEndpoint = "/grpc/emissary.EmissaryPublic/UpdateInstalledIntegration";
  /** Update the installation settings of an integration */
  export function UpdateInstalledIntegration(sender: (req: UpdateInstalledIntegrationRequest, endpoint: string) => Promise<InstalledIntegration>, req: UpdateInstalledIntegrationRequest): { promise: () => Promise<InstalledIntegration>, endpoint: string } {
    return {
      promise: () => sender(req, UpdateInstalledIntegrationEndpoint),
      endpoint: UpdateInstalledIntegrationEndpoint
    };
  }

  export const ConvertIntegrationScopeEndpoint = "/grpc/emissary.EmissaryPublic/ConvertIntegrationScope";
  /** Convert an installed integration to use a different configuration scope. Warning: All existing configs will be deleted. */
  export function ConvertIntegrationScope(sender: (req: ConvertIntegrationScopeRequest, endpoint: string) => Promise<InstalledIntegration>, req: ConvertIntegrationScopeRequest): { promise: () => Promise<InstalledIntegration>, endpoint: string } {
    return {
      promise: () => sender(req, ConvertIntegrationScopeEndpoint),
      endpoint: ConvertIntegrationScopeEndpoint
    };
  }

  export const UninstallIntegrationEndpoint = "/grpc/emissary.EmissaryPublic/UninstallIntegration";
  /** Removes the integration from the org and returns a redirect URL, if any. */
  export function UninstallIntegration(sender: (req: UninstallIntegrationRequest, endpoint: string) => Promise<{}>, req: UninstallIntegrationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, UninstallIntegrationEndpoint),
      endpoint: UninstallIntegrationEndpoint
    };
  }

  export const DeprecatedInstallIntegrationEndpoint = "/grpc/emissary.EmissaryPublic/DeprecatedInstallIntegration";
  /** Deprecated: Install and add configuration for an integration to an org. */
  export function DeprecatedInstallIntegration(sender: (req: DeprecatedInstallIntegrationRequest, endpoint: string) => Promise<IntegrationConfig>, req: DeprecatedInstallIntegrationRequest): { promise: () => Promise<IntegrationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, DeprecatedInstallIntegrationEndpoint),
      endpoint: DeprecatedInstallIntegrationEndpoint
    };
  }

  export const GetAuthUrlEndpoint = "/grpc/emissary.EmissaryPublic/GetAuthUrl";
  /** Gets the authorization URL for an OAuth integration. */
  export function GetAuthUrl(sender: (req: GetAuthUrlRequest, endpoint: string) => Promise<GetAuthUrlResponse>, req: GetAuthUrlRequest): { promise: () => Promise<GetAuthUrlResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthUrlEndpoint),
      endpoint: GetAuthUrlEndpoint
    };
  }

  export const GetAuthTokenStatusesEndpoint = "/grpc/emissary.EmissaryPublic/GetAuthTokenStatuses";
  /** Gets the auth token status for all authed integrations for org */
  export function GetAuthTokenStatuses(sender: (req: GetAuthTokenStatusesRequest, endpoint: string) => Promise<GetAuthTokenStatusesResponse>, req: GetAuthTokenStatusesRequest): { promise: () => Promise<GetAuthTokenStatusesResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAuthTokenStatusesEndpoint),
      endpoint: GetAuthTokenStatusesEndpoint
    };
  }

  export const GetAutocompleteValuesEndpoint = "/grpc/emissary.EmissaryPublic/GetAutocompleteValues";
  /** Get autocomplete field values for sending Notes. */
  export function GetAutocompleteValues(sender: (req: AutocompleteRequest, endpoint: string) => Promise<AutocompleteResponse>, req: AutocompleteRequest): { promise: () => Promise<AutocompleteResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetAutocompleteValuesEndpoint),
      endpoint: GetAutocompleteValuesEndpoint
    };
  }

  export const CreateIntegrationConfigEndpoint = "/grpc/emissary.EmissaryPublic/CreateIntegrationConfig";
  /** Creates a new integration config for an org or user. */
  export function CreateIntegrationConfig(sender: (req: CreateIntegrationConfigRequest, endpoint: string) => Promise<IntegrationConfig>, req: CreateIntegrationConfigRequest): { promise: () => Promise<IntegrationConfig>, endpoint: string } {
    return {
      promise: () => sender(req, CreateIntegrationConfigEndpoint),
      endpoint: CreateIntegrationConfigEndpoint
    };
  }

  export const DeleteIntegrationConfigEndpoint = "/grpc/emissary.EmissaryPublic/DeleteIntegrationConfig";
  /** Allows admins/users to delete their integration configs. */
  export function DeleteIntegrationConfig(sender: (req: DeleteIntegrationConfigRequest, endpoint: string) => Promise<{}>, req: DeleteIntegrationConfigRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteIntegrationConfigEndpoint),
      endpoint: DeleteIntegrationConfigEndpoint
    };
  }

  export const GetIntegrationUsersEndpoint = "/grpc/emissary.EmissaryPublic/GetIntegrationUsers";
  export function GetIntegrationUsers(sender: (req: GetIntegrationUsersRequest, endpoint: string) => Promise<GetIntegrationUsersResponse>, req: GetIntegrationUsersRequest): { promise: () => Promise<GetIntegrationUsersResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationUsersEndpoint),
      endpoint: GetIntegrationUsersEndpoint
    };
  }

  export const ValidateIntegrationsEndpoint = "/grpc/emissary.EmissaryPublic/ValidateIntegrations";
  export function ValidateIntegrations(sender: (req: ValidateIntegrationsRequest, endpoint: string) => Promise<ValidateIntegrationsResponse>, req: ValidateIntegrationsRequest): { promise: () => Promise<ValidateIntegrationsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ValidateIntegrationsEndpoint),
      endpoint: ValidateIntegrationsEndpoint
    };
  }

  export const ConnectIntegrationEndpoint = "/grpc/emissary.EmissaryPublic/ConnectIntegration";
  export function ConnectIntegration(sender: (req: ConnectIntegrationRequest, endpoint: string) => Promise<ConnectIntegrationResponse>, req: ConnectIntegrationRequest): { promise: () => Promise<ConnectIntegrationResponse>, endpoint: string } {
    return {
      promise: () => sender(req, ConnectIntegrationEndpoint),
      endpoint: ConnectIntegrationEndpoint
    };
  }

  export const DisconnectIntegrationEndpoint = "/grpc/emissary.EmissaryPublic/DisconnectIntegration";
  export function DisconnectIntegration(sender: (req: DisconnectIntegrationRequest, endpoint: string) => Promise<{}>, req: DisconnectIntegrationRequest): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DisconnectIntegrationEndpoint),
      endpoint: DisconnectIntegrationEndpoint
    };
  }

  export const GetIntegrationConfigOptionsEndpoint = "/grpc/emissary.EmissaryPublic/GetIntegrationConfigOptions";
  export function GetIntegrationConfigOptions(sender: (req: GetIntegrationConfigOptionsRequest, endpoint: string) => Promise<IntegrationDetails>, req: GetIntegrationConfigOptionsRequest): { promise: () => Promise<IntegrationDetails>, endpoint: string } {
    return {
      promise: () => sender(req, GetIntegrationConfigOptionsEndpoint),
      endpoint: GetIntegrationConfigOptionsEndpoint
    };
  }

  export const ValidateIntegrationConfigOptionsEndpoint = "/grpc/emissary.EmissaryPublic/ValidateIntegrationConfigOptions";
  export function ValidateIntegrationConfigOptions(sender: (req: ValidateIntegrationConfigOptionsRequest, endpoint: string) => Promise<IntegrationValidationResult>, req: ValidateIntegrationConfigOptionsRequest): { promise: () => Promise<IntegrationValidationResult>, endpoint: string } {
    return {
      promise: () => sender(req, ValidateIntegrationConfigOptionsEndpoint),
      endpoint: ValidateIntegrationConfigOptionsEndpoint
    };
  }

  export const SendTestContentEndpoint = "/grpc/emissary.EmissaryPublic/SendTestContent";
  export function SendTestContent(sender: (req: SendTestContentRequest, endpoint: string) => Promise<SendContentResult>, req: SendTestContentRequest): { promise: () => Promise<SendContentResult>, endpoint: string } {
    return {
      promise: () => sender(req, SendTestContentEndpoint),
      endpoint: SendTestContentEndpoint
    };
  }

  export const GetSendContentAttemptsEndpoint = "/grpc/emissary.EmissaryPublic/GetSendContentAttempts";
  /** Gets the details for send content attempts for a given integration config. */
  export function GetSendContentAttempts(sender: (req: GetSendContentAttemptsRequest, endpoint: string) => Promise<GetSendContentAttemptsResponse>, req: GetSendContentAttemptsRequest): { promise: () => Promise<GetSendContentAttemptsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetSendContentAttemptsEndpoint),
      endpoint: GetSendContentAttemptsEndpoint
    };
  }

  export const GetBucketedSendContentAttemptCountsEndpoint = "/grpc/emissary.EmissaryPublic/GetBucketedSendContentAttemptCounts";
  /** Gets time-bucketed counts of send content attempts, broken down by error code */
  export function GetBucketedSendContentAttemptCounts(sender: (req: GetBucketedSendContentAttemptCountsRequest, endpoint: string) => Promise<GetBucketedSendContentAttemptCountsResponse>, req: GetBucketedSendContentAttemptCountsRequest): { promise: () => Promise<GetBucketedSendContentAttemptCountsResponse>, endpoint: string } {
    return {
      promise: () => sender(req, GetBucketedSendContentAttemptCountsEndpoint),
      endpoint: GetBucketedSendContentAttemptCountsEndpoint
    };
  }
}

export namespace Cron {

  export const DeleteTombstonedIntegrationInstallationsEndpoint = "/grpc/emissary.Cron/DeleteTombstonedIntegrationInstallations";
  export function DeleteTombstonedIntegrationInstallations(sender: (req: {}, endpoint: string) => Promise<{}>, req: {}): { promise: () => Promise<{}>, endpoint: string } {
    return {
      promise: () => sender(req, DeleteTombstonedIntegrationInstallationsEndpoint),
      endpoint: DeleteTombstonedIntegrationInstallationsEndpoint
    };
  }
}

export interface GetIntegrationConfigSummariesRequest {
  orgId: string;
  /**
   * a list of config ids to build summaries for. the content of the summary will depend on the current users relationship
   * to the config requested. user's accessing a config they cannot write to will see a more generalized message.
   */
  integrationConfigIds: string[];
}

export interface GetIntegrationConfigSummariesResponse {
  /** a map of config ids to specific summaries */
  configSummaries: { [key: string]: IntegrationConfigSummary };
}

export interface IntegrationConfigSummary {
  /** identifier of the integration service/provider, e.g. intercom, slack, etc. */
  serviceId: string;
  /** the user who can address issues with an integration config or its related connection */
  owner: string;
  /**
   * a general description of the resources this config can connect to. if the requesting user cannot write
   * to the the summary, a generic response is provided instead.
   */
  header: string;
  /** additional details are only shown if the requesting user is also the owner of the summary. */
  details: string[];
  /**
   * whether the integration is considered to be configured; may be based on configuration and related connection
   * values.
   */
  isConfigured: boolean;
}

export interface GetIntegrationUsersRequest {
  orgId: string;
  installationId: string;
}

export interface GetIntegrationUsersResponse {
  users: IntegrationUser[];
}

export interface IntegrationUser {
  email: string;
  updatedAt: protobuf.timestamp | null;
}

export interface SendNoteRequest {
  orgId: string;
  /** ID of the integration to send note to */
  integrationId: string;
  /** Note object */
  note: Note | null;
  /** NoteUrl is needed because it must be calculated on the frontend for Highlights */
  noteUrl: string;
  /** fieldkey -> value */
  modalFields: { [key: string]: string };
}

export interface SendNoteResponse {
  errorMsg: string;
  /** Indicates whether a modal dialog should be displayed to allow field configuration */
  modalRequired: boolean;
  /** Set IFF ModalRequired = true */
  modal: SendModal | null;
  /** Will not be set if ModalRequired = true */
  url: string;
  /** An Enum for specific error that may require special handling */
  errorType: SendNoteResponseError;
}

export enum SendNoteResponseError {
  UNKNOWN = 0,
  ALREADY_SENT = 1
}

export interface BroadcastNoteRequest {
  orgId: string;
  note: Note | null;
  /** NoteUrl is needed because it must be calculated on the frontend for Highlights */
  noteUrl: string;
}

export interface BroadcastNoteResponse {
  /** Map of provider ID -> URL (from SendNoteResponse) for each integration that the note was broadcast to */
  sentIntegrations: { [key: string]: string };
}

export interface SendNoteIntegrationsRequest {
  orgId: string;
}

export interface SendNoteIntegrationsResponse {
  /** id -> provider name */
  integrations: { [key: string]: string };
}

export interface IntegrationScriptsRequest {
  orgId: string;
}

export interface IntegrationScriptsResponse {
  scripts: string;
}

export interface IntegrationConfig {
  /** identifier of the integration service/provider, e.g. intercom, slack, etc. */
  serviceId: string;
  enabled: boolean;
  config: { [key: string]: string };
  /** unique ID of integration within the Org */
  id: string;
  /** unique ID of integration installation in the org */
  installationId: string;
  /** seat ID (email) of the user that created this config */
  owner: string;
  /** unique ID of integration connection associated with this config, if any exists */
  connectionId: string;
  /**
   * origin represents the feature context within which an integration config was created and the feature to which
   * usage of the config should be attributed. When integration configs are deleted, this origin is included as an
   * attribute on a Pub/Sub message communicating the deletion. This origin attribute can be used by Pub-Sub subscribers
   * to filter their Pub/Sub subscription to those messages they care about.
   */
  origin: string;
  /**
   * source id is a client/producer-owned, immutable id which can be used to send content to integrations. This value
   * is given on integration config creation and later used to call e.g. ScheduleContent to send content using any
   * integration configs associated with the source id. For Destination Studio, this is expected to be the signal
   * definition id.
   */
  sourceId: string;
  /** The timestamp at which this integration config was created */
  createdAt: protobuf.timestamp | null;
  /** The number of successful times we have sent content in the last 7 days. */
  sendContentSuccessCount7Day: protobuf.int64;
  /** The last time the enabled switch was flipped. */
  enabledLastUpdatedAt: protobuf.timestamp | null;
}

export interface IntegrationDetails {
  /** true if fields should be displayed (i.e., the service is initialized) */
  showFields: boolean;
  /** fieldname->key->value */
  enums: { [key: string]: DetailEnumMap };
  /** fieldname->href */
  links: { [key: string]: string };
  /** fieldname->linktext  (optional; if not present for a link, the IntgConfigField value is used) */
  linkTexts: { [key: string]: string };
  /** fieldname->text (used for paragraph types and alt-text for link types) */
  paragraphTexts: { [key: string]: string };
}

export interface InstalledIntegration {
  /** unique ID of the integration installation within an org */
  installationId: string;
  /** identifier of the integration service/provider */
  serviceId: string;
  /** scope of the configuration objects, e.g. ORG for global config or USER for individual config */
  configScope: ConfigurationScope;
  /** whether the integration is enabled for usage in the org */
  enabled: boolean;
  /** the time at which the installation was last updated */
  updatedAt: protobuf.timestamp | null;
  /** the user that last updated the installation */
  updatedBy: string;
}

export enum ConfigurationScope {
  CONFIGURATION_SCOPE_UNSET = 0,
  CONFIGURATION_SCOPE_USER = 1,
  CONFIGURATION_SCOPE_ORG = 2
}

export interface IntegrationConnection {
  connectionId: string;
  installationId: string;
  properties: { [key: string]: string };
  owner: string;
}

export interface IntegrationListing {
  serviceId: string;
  name: string;
  icon: string;
  description: string;
  helpUrl: string;
  configItems: IntegrationField[];
  usesAuth: boolean;
  canEnable: boolean;
  supportsUserConfigScope: boolean;
  connectionProperties: IntegrationField[];
}

export interface DetailEnumMap {
  kvs: { [key: string]: string };
}

export interface GetAvailableIntegrationsRequest {
  orgId: string;
  capabilities: Capability[];
}

export interface GetAvailableIntegrationsResponse {
  integrations: IntegrationListing[];
}

export interface GetInstalledIntegrationsRequest {
  orgId: string;
}

/**
 * IntegrationModel represents the hierarchy of objects that are used to describe an integration. The
 * InstalledIntegration, the configs that belong to it, and the associated connection are all presented in a single
 * message.
 */
export interface IntegrationModel {
  installed: InstalledIntegration | null;
  /** Integration configs which the user is permitted to access and which are related to this installation. */
  configs: IntegrationConfig[];
  /**
   * The connection under which a user will access the installation, if connected. For org-scoped
   * installations, this will be the connection shared across the org. For user-scoped
   * installations, this will be the user's personal connection. May be nil.
   */
  connection: IntegrationConnection | null;
  /**
   * Indicates whether the connection has the necessary values set to connect to the destination, e.g. an OAuth token or
   * API key
   */
  isConnected: boolean;
}

export interface GetInstalledIntegrationsResponse {
  models: IntegrationModel[];
}

export interface IntegrationDetailsRequest {
  orgId: string;
  /** unique identifier returned from the add integration process */
  integrationId: string;
}

export interface IntegrationDetailsByProviderIdRequest {
  orgId: string;
  /** identifier of the integration service/provider, e.g. intercom, slack, etc. */
  providerId: string;
}

export interface ConnectionByServiceIdRequest {
  orgId: string;
  providerId: string;
  owner: string;
}

export interface InstallIntegrationRequest {
  orgId: string;
  /** identifier of the integration service/provider, e.g. intercom, slack, etc. */
  serviceId: string;
}

export interface DeprecatedInstallIntegrationRequest {
  orgId: string;
  /** identifier of the integration service/provider, e.g. intercom, slack, etc. */
  serviceId: string;
}

export interface UpdateIntegrationConfigRequest {
  orgId: string;
  integrationId: string;
  enabled: boolean | null;
  /** optional auth_token; will not be changed if this value is not set */
  authToken: string | null;
  /** config settings will be merged in an additive fashion with existing config */
  config: { [key: string]: string };
}

export interface UpdateInstalledIntegrationRequest {
  orgId: string;
  installationId: string;
  /** if set, will enable or disable the integration */
  enabled: boolean | null;
}

export interface ConvertIntegrationScopeRequest {
  orgId: string;
  installationId: string;
}

export interface UninstallIntegrationRequest {
  orgId: string;
  integrationId: string;
  installationId: string;
}

export interface ConnectIntegrationRequest {
  orgId: string;
  installationId: string;
  properties: { [key: string]: string };
}

export interface ConnectIntegrationResponse {
  connectionId: string;
}

export interface UpdateIntegrationConnectionRequest {
  orgId: string;
  connectionId: string;
  updateProperties: { [key: string]: string };
}

export interface DisconnectIntegrationRequest {
  orgId: string;
  connectionId: string;
}

export interface AutocompleteRequest {
  orgId: string;
  integrationId: string;
  /** identifier of the field for which data is being fetched */
  fieldId: string;
  /** additional search parameter(s) to use to fetch data */
  searchParam: string;
  /** fieldID -> value */
  modalFields: { [key: string]: string };
}

export interface AutocompleteResponse {
  integrationId: string;
  fieldId: string;
  options: AutocompleteOption[];
}

export interface AutocompleteOption {
  id: string;
  value: string;
}

export interface SendNoteModalRequest {
  orgId: string;
  integrationId: string;
  note: Note | null;
  /** NoteUrl is needed because it must be calculated on the frontend for Highlights */
  noteUrl: string;
  /** fieldID -> value */
  modalFields: { [key: string]: string };
}

export interface SendNoteModalResponse {
  modal: SendModal | null;
}

export interface UserCardUrlsRequest {
  orgId: string;
  appKey: string;
  email: string;
  userVars: vars.Var[];
}

export interface UserCardUrlsResponse {
  /** key is text to be displayed for link */
  links: { [key: string]: UserDetailLink };
}

export interface GetAuthUrlRequest {
  orgId: string;
  integrationId: string;
}

export interface GetAuthUrlResponse {
  /** Identifier for the client key. */
  url: string;
}

export interface UpdateAuthTokenRequest {
  orgId: string;
  code: string;
  state: string;
}

export interface UpdateAuthTokenResponse {
  integrationId: string;
}

export interface UpdateAuthTokenOAuth1Request {
  orgId: string;
  intgId: string;
  serviceId: string;
  token: string;
  oauthToken: string;
  oauthVerifier: string;
}

export interface UpdateAuthTokenOAuth1Response {
  integrationId: string;
}

export interface GetAuthTokenStatusRequest {
  orgId: string;
  /** unique identifier returned from the add integration process */
  integrationId: string;
}

export interface GetAuthTokenStatusResponse {
  valid: boolean;
}

export interface GetAuthTokenStatusesRequest {
  orgId: string;
}

export enum AuthTokenStatus {
  TOKEN_STATUS_UNKNOWN = 0,
  TOKEN_STATUS_INVALID = 1,
  TOKEN_STATUS_VALID = 2
}

export interface GetAuthTokenStatusesResponse {
  /**
   * map of provider_id and validation result
   * 
   * @deprecated
   */
  statuses: { [key: string]: boolean };
  tokenStatuses: { [key: string]: AuthTokenStatus };
}

export interface CreateIntegrationConfigRequest {
  orgId: string;
  installationId: string;
  /**
   * origin represents the feature context within which an integration config was created and the feature to which
   * usage of the config should be attributed. When integration configs are deleted, this origin is included as an
   * attribute on a Pub/Sub message communicating the deletion. This origin attribute can be used by Pub/Sub subscribers
   * to filter their Pub/Sub subscription to those messages they care about. Must be an allowed value.
   * TODO(nate): Consider converting origin to an enum and translating to expected string values already in use.
   */
  origin: string;
  connectionId: string;
  /**
   * Optional: source id is a client/producer-owned, immutable id which can be used to send content to integrations.
   * This value is given on integration config creation and later used to call e.g. ScheduleContent to send content
   * using any integration configs associated with the source id. For Destination Studio, this is expected to be the
   * signal definition id.
   */
  sourceId: string;
  /** Optional configuration properties for the integration (e.g. Slack channel id, Jira project id, etc.). */
  properties: { [key: string]: string };
}

export interface DeleteIntegrationConfigRequest {
  orgId: string;
  configId: string;
}

export interface SendContentMessageContent {
  header: string;
  body: string;
  actions: SendContentMessageContent.Action[];
}

export namespace SendContentMessageContent {
  export interface Action {
    label: string;
    url: string;
  }
}

export interface IntegrationContent {
  genericContent?: SendContentMessageContent | null;
  signalMatch?: signalstudio.SignalMatch | null;
  /** Time at which the content expires. Content will not be sent after this time. */
  expiresAt: protobuf.timestamp | null;
}

export namespace IntegrationContent {
  export enum value {
    genericContent = 1,
    signalMatch = 2
  }

  export function value_oneof(m: IntegrationContent): { opt: value.genericContent, val: SendContentMessageContent } | { opt: value.signalMatch, val: signalstudio.SignalMatch } | null {
    if (m.genericContent != null) { return { opt: value.genericContent, val: m.genericContent } }
    if (m.signalMatch != null) { return { opt: value.signalMatch, val: m.signalMatch } }
    return null;
  }
}

export enum SendContentErrorCode {
  SEND_CONTENT_ERROR_CODE_UNSET = 0,
  SEND_CONTENT_ERROR_CODE_OTHER = 1,
  /** Integration may have been uninstalled. */
  SEND_CONTENT_ERROR_CODE_INTEGRATION_NOT_FOUND = 2,
  /** Integration is disabled and cannot be invoked. */
  SEND_CONTENT_ERROR_CODE_INTEGRATION_DISABLED = 3,
  /** Integration config may have been deleted (e.g. on seat removal). */
  SEND_CONTENT_ERROR_CODE_CONFIG_NOT_FOUND = 4,
  /**
   * Integration config may be in an invalid state (e.g. missing required config values
   * like destination Slack channel).
   */
  SEND_CONTENT_ERROR_CODE_CONFIG_INVALID = 5,
  /**
   * The given integration config is associated with a connection that has an invalid
   * access token (may have expired or been revoked e.g. directly in Slack).
   */
  SEND_CONTENT_ERROR_CODE_CONNECTION_INVALID = 6,
  /**
   * The given user doesn't have access to the given integration config (e.g. config
   * belongs to another user).
   */
  SEND_CONTENT_ERROR_CODE_CONFIG_ACCESS_FORBIDDEN = 7,
  /** The message is too old to process. */
  SEND_CONTENT_ERROR_CODE_MESSAGE_EXPIRED = 8,
  /** The given integration config is disabled (e.g. status toggled to "off"). */
  SEND_CONTENT_ERROR_CODE_CONFIG_DISABLED = 9,
  /** Content with the same idempotence key has already been sent. */
  SEND_CONTENT_ERROR_CODE_CONTENT_ALREADY_SENT = 10,
  /** Content is not deliverable e.g. due to bad request or not found HTTP response status code. */
  SEND_CONTENT_ERROR_CODE_CONTENT_NOT_DELIVERABLE = 11,
  /** Downstream destination took too long to respond */
  SEND_CONTENT_ERROR_CODE_TIMED_OUT = 12,
  /** We're deliberately not sending content because a kill switch is enabled. */
  SEND_CONTENT_ERROR_CODE_KILL_SWITCHED = 13,
  /** The destination system has refused our connection. */
  SEND_CONTENT_ERROR_CODE_CONNECTION_REFUSED = 14,
  SEND_CONTENT_ERROR_CODE_NO_SUCH_HOST = 15,
  /** The preflight request to fetch an OAuth token failed */
  SEND_CONTENT_ERROR_CODE_OAUTH_REQUEST_FAILED = 16,
  /** The destination system's response indicates that the request may succeed if retried (e.g. 429 status code) */
  SEND_CONTENT_ERROR_CODE_RESPONSE_RETRYABLE = 17
}

export interface SendContentError {
  code: SendContentErrorCode;
  webhook?: WebhookSendContentMetadata | null;
}

export namespace SendContentError {
  /** Optional, provider-specific metadata related to a failed content send (e.g. webhook HTTP status code). */
  export enum metadata {
    webhook = 2
  }

  /** Optional, provider-specific metadata related to a failed content send (e.g. webhook HTTP status code). */
  export function metadata_oneof(m: SendContentError): { opt: metadata.webhook, val: WebhookSendContentMetadata } | null {
    if (m.webhook != null) { return { opt: metadata.webhook, val: m.webhook } }
    return null;
  }
}

export interface SendContentSuccess {
  sentAt: protobuf.timestamp | null;
  webhook?: WebhookSendContentMetadata | null;
}

export namespace SendContentSuccess {
  /** Optional, provider-specific metadata related to a successful content send (e.g. webhook HTTP status code). */
  export enum metadata {
    webhook = 2
  }

  /** Optional, provider-specific metadata related to a successful content send (e.g. webhook HTTP status code). */
  export function metadata_oneof(m: SendContentSuccess): { opt: metadata.webhook, val: WebhookSendContentMetadata } | null {
    if (m.webhook != null) { return { opt: metadata.webhook, val: m.webhook } }
    return null;
  }
}

export interface SendContentResult {
  success?: SendContentSuccess | null;
  error?: SendContentError | null;
}

export namespace SendContentResult {
  export enum result {
    success = 1,
    error = 2
  }

  export function result_oneof(m: SendContentResult): { opt: result.error, val: SendContentError } | { opt: result.success, val: SendContentSuccess } | null {
    if (m.success != null) { return { opt: result.success, val: m.success } }
    if (m.error != null) { return { opt: result.error, val: m.error } }
    return null;
  }
}

/**
 * SendContentJob represents the proto job expected to be scheduled on the
 * send-content-queue Pub/Sub topic.
 */
export interface SendContentJob {
  orgId: string;
  integrationConfigId: string;
  /**
   * Deprecated; prefer specifying the payload property instead.
   * 
   * @deprecated
   */
  content: SendContentMessageContent | null;
  /**
   * Messages 24h after this timestamp will no longer be retried. Prefer specifying IntegrationContent.expires_at
   * instead.
   * 
   * @deprecated
   */
  timestamp: protobuf.timestamp | null;
  /**
   * origin should be a unique string representing a single publisher; this string is
   * echoed in completion topic message attributes to enable completion topic filtering.
   * Deprecated; we will stop publishing completion topic messages. There are no
   * subscribers and no anticipated subscribers as Emissary becomes responsible for
   * activity logging and health checks.
   * 
   * @deprecated
   */
  origin: string;
  /**
   * correlation_id is expected to be used by publishers to relate completion topic
   * messages to significant originating activities (e.g. the id of a notification
   * that was being sent to a third-party integration). correlation_id is echoed
   * in completion topic messages.
   * Deprecated; we will stop publishing completion topic messages. There are no
   * subscribers and no anticipated subscribers as Emissary becomes responsible for
   * activity logging and health checks.
   * 
   * @deprecated
   */
  correlationId: string;
  payload: IntegrationContent | null;
  /**
   * Optional, but highly encouraged to reduce the likelihood that we send the given
   * content multiple times.
   */
  idempotenceKey: string;
  /** Optional. Used to measure processing latency. Do not set unless you intend to affect processing metrics. */
  processedAt: protobuf.timestamp | null;
}

/**
 * SendContentAttempt records an attempt to deliver the content to a destination. This may exist
 * several times for a single content ID. These records are what we will use to determine usage
 * and failure rate for a stream.
 */
export interface SendContentAttempt {
  orgId: string;
  integrationConfigId: string;
  attemptedAt: protobuf.timestamp | null;
  content: IntegrationContent | null;
  result: SendContentResult | null;
  idempotenceKey: string;
}

/**
 * IntegrationConfigDeletion is the Proto message payload that is published to Pub/Sub any time an integration config
 * not owned by Emissary is deleted.
 */
export interface IntegrationConfigDeletion {
  orgId: string;
  integrationConfigId: string;
  origin: string;
  sourceId: string;
}

export enum IntegrationValidationStatus {
  INTEGRATION_VALIDATION_STATUS_UNKNOWN = 0,
  INTEGRATION_VALIDATION_STATUS_VALID = 1,
  INTEGRATION_VALIDATION_STATUS_CONNECTION_INVALID = 2,
  INTEGRATION_VALIDATION_STATUS_CONFIG_INVALID = 3,
  INTEGRATION_VALIDATION_STATUS_CONFIG_INCOMPLETE = 4
}

export interface IntegrationValidationResult {
  status: IntegrationValidationStatus;
  /** Map of field key to error message. Empty string key indicates an error not linked to a specific field. */
  errors: { [key: string]: string };
}

export interface ValidateIntegrationsRequest {
  orgId: string;
  integrationConfigIds: string[];
}

export interface ValidateIntegrationsResponse {
  /** Map of integration config id to validation result. */
  results: { [key: string]: IntegrationValidationResult };
}

export interface ValidateIntegrationConfigOptionsRequest {
  orgId: string;
  configId: string;
  properties: { [key: string]: string };
}

export interface GetIntegrationConfigOptionsRequest {
  orgId: string;
  configId: string;
  properties: { [key: string]: string };
}

export interface SendTestContentRequest {
  orgId: string;
  installationId: string;
  configProperties: { [key: string]: string };
  content: IntegrationContent | null;
  configId: string;
  mapping: mapping.Mapping | null;
  mappingHoistProperties: boolean;
  connectionId: number;
}

export interface GetSendContentAttemptsRequest {
  orgId: string;
  integrationConfigId: string;
  idempotenceKey: string;
  limit: number;
  paginationToken: string;
}

export interface GetSendContentAttemptsResponse {
  attempts: SendContentAttempt[];
  nextPageToken: string;
}

export enum BucketSize {
  BUCKET_SIZE_UNSET = 0,
  BUCKET_SIZE_HOURLY = 1,
  BUCKET_SIZE_DAILY = 2
}

export interface GetBucketedSendContentAttemptCountsRequest {
  orgId: string;
  integrationConfigId: string;
  startTime: protobuf.timestamp | null;
  endTime: protobuf.timestamp | null;
  bucketSize: BucketSize;
}

export interface GetBucketedSendContentAttemptCountsResponse {
  buckets: GetBucketedSendContentAttemptCountsResponse.Bucket[];
}

export namespace GetBucketedSendContentAttemptCountsResponse {
  export interface Bucket {
    /** The start time of the bucket. The size of the bucket was specified in the request. */
    startTime: protobuf.timestamp | null;
    /** The number of attempts, broken down by emissary.SendContentErrorCode */
    counts: GetBucketedSendContentAttemptCountsResponse.Bucket.Count[];
  }

  export namespace Bucket {
    export interface Count {
      code: SendContentErrorCode;
      count: protobuf.int64;
    }
  }
}
